import { Component, h, Prop, Event, EventEmitter } from '@stencil/core';

@Component({
  tag: 'sg-app',
  styleUrl: '../../toolkit/toolkit_v2.css',
  shadow: true
})
export class SolutionGuideApplication {

  @Prop() origin: string;
  @Prop() country: string;
  @Prop() type: string;
  @Prop() language: string;
  @Prop() showhome?: boolean;
  @Prop() name?: string;
  @Prop() user?: string;
  @Prop() email?: string;

  private textsMap: Map<string, any> = new Map();

  //private langService: LangService = new LangService();

  @Event({
    eventName: "referencePoll",
    bubbles: false,
  }) referencePoll: EventEmitter<string>;

  onSelectedPoll(event: CustomEvent<string>) {
    this.type = event.detail;
  }

  async componentWillLoad() {
    if (!this.user) {
      this.user = undefined;
    }
    if (!this.email) {
      this.email = undefined;
    }
    if (this.showhome === undefined) {
      this.showhome = false;
    }

    // Configurar los encabezados de la solicitud
    const headers = new Headers();
    headers.append('Authorization', `Basic ${process.env.SERVICES_TOKEN}`);
    headers.append('Content-Type', 'application/json');

    const requestOptions = {
      method: 'GET',
      headers: headers
    };

    try {
      const response = await fetch(`${process.env.SERVICES_API}/texts/${this.language}`, requestOptions);
      if (!response.ok) {
        throw new Error('La solicitud no se completó correctamente');
      }
      const data = await response.json();

      // Llenar el Map con los datos obtenidos
      for (const [clave, valor] of Object.entries(data)) {
        this.textsMap.set(clave, valor);
      }
      //console.log("captura..: " + JSON.stringify(mapTexts));
    } catch (error) {
      console.error('Ocurrió un error leyendo textos:', error);
    }

  }

  onShowPollHome(event: CustomEvent<boolean>) {
    this.showhome = event.detail;
  }

  onSelectedPollHome(event: CustomEvent<string>) {
    this.type = event.detail;
    this.showhome = false;
  }

  onReferencePoll(event: CustomEvent<string>) {
    this.referencePoll.emit(event.detail)

  }
  render() {
    console.log("ambiente: " + process.env.SERVICES_API);
    console.log("country:  " + this.country);
    console.log("origin:  " + this.origin);
    console.log("type: " + this.type);
    console.log("email: " + this.email);
    console.log("name: " + this.name);
    console.log("language: " + this.language);
    console.log("showhome: " + this.showhome);

    return (
      <div class="html" id="solutionGuide">
        <div class="body">
          {
            this.type ?
              this.showhome ?
                <sg-home origin={this.origin} country={this.country} type={this.type} textsMap={this.textsMap} onSelectedPollHome={e => this.onSelectedPollHome(e)}></sg-home>
                :
                <component-poll origin={this.origin} type={this.type} textsMap={this.textsMap} email={this.email} user={this.user} name={this.name}
                  country={this.country} onReferencePoll={e => this.onReferencePoll(e)}></component-poll>
              :
              <sg-prehome origin={this.origin} country={this.country} textsMap={this.textsMap} showhome={this.showhome} onSelectedPoll={e => this.onSelectedPoll(e)} onShowPollHome={e => this.onShowPollHome(e)} ></sg-prehome>
          }
        </div>
      </div>
    );
  }
}
